/**
 * Converte uma string (lower case) em uma string sem caracteres acentuados.
 * 
 * @param  {String} string acentuada
 * @return {String} string sem acentos
 */
export default function normalizeString(string) {
	var replaceMap = {
		a : /[\xE0-\xE6]/g,
		e : /[\xE8-\xEB]/g,
		i : /[\xEC-\xEF]/g,
		o : /[\xF2-\xF6]/g,
		u : /[\xF9-\xFC]/g,
		c : /\xE7/g,
		n : /\xF1/g
	};

	for (var char in replaceMap) {
		var regex = replaceMap[char];
		string = string.replace(regex, char);
	}
	return string;
}